import {
  InitialWeekDayType,
  ShortWeekDayType,
  WeekDayType,
} from "@/TS/Types/global_types";

const _dayKeys = [1, 2, 3, 4, 5, 6, 7] as const;

export const days: Record<
  (typeof _dayKeys)[number],
  { initial: InitialWeekDayType; short: ShortWeekDayType; long: WeekDayType }
> = {
  1: {
    initial: "L",
    short: "Lun",
    long: "Lundi",
  },
  2: {
    initial: "M",
    short: "Mar",
    long: "Mardi",
  },
  3: {
    initial: "M",
    short: "Mer",
    long: "Mercredi",
  },
  4: {
    initial: "J",
    short: "Jeu",
    long: "Jeudi",
  },
  5: {
    initial: "V",
    short: "Ven",
    long: "Vendredi",
  },
  6: {
    initial: "S",
    short: "Sam",
    long: "Samedi",
  },
  7: {
    initial: "D",
    short: "Dim",
    long: "Dimanche",
  },
};
export const monthes = {
  january: {
    initial: "J",
    short: "Jan",
    long: "Janvier",
  },
  february: {
    initial: "F",
    short: "Fév",
    long: "Février",
  },
  march: {
    initial: "M",
    short: "Mar",
    long: "Mars",
  },
  april: {
    initial: "A",
    short: "Avr",
    long: "Avril",
  },
  may: {
    initial: "M",
    short: "Mai",
    long: "Mai",
  },
  june: {
    initial: "J",
    short: "Juin",
    long: "Juin",
  },
  july: {
    initial: "J",
    short: "Juil",
    long: "Juillet",
  },
  august: {
    initial: "A",
    short: "Août",
    long: "Août",
  },
  september: {
    initial: "S",
    short: "Sep",
    long: "Septembre",
  },
  october: {
    initial: "O",
    short: "Oct",
    long: "Octobre",
  },
  november: {
    initial: "N",
    short: "Nov",
    long: "Novembre",
  },
  december: {
    initial: "D",
    short: "Déc",
    long: "Décembre",
  },
};
